import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const getAllNotifications = createAsyncThunk(
  "apiNotifications/getAllNotifications",
  async (params = {}, thunkAPI) => {
    try {
      const { page = 1 } = params;
      const response = await axiosInstance.get(`/notifications/allNotifications?page=${page}&limit=8`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createNotification = createAsyncThunk(
  "apiNotifications/createNotification",
  async (data, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/notifications/create", data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteNotification = createAsyncThunk(
  "apiNotifications/deleteNotification",
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`/notifications/deleteNotification/${id}`);
      return { id, ...response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const apiNotificationsSlice = createSlice({
  name: "apiNotifications",
  initialState: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNotification.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.loading = false;
        if (state.data && Array.isArray(state.data.data)) {
          state.data.data = state.data.data.filter((item) => item.id !== action.payload.id);
        }
      })
      .addCase(deleteNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPage } = apiNotificationsSlice.actions;

export default apiNotificationsSlice.reducer; 